export default __webpack_public_path__ + "static/media/Erlin_Kakkanad_AHV_In_Moms_We_Trust.e159fe30.jpg";